import Select, { Props } from 'react-select'
import { MenuList } from './menu-list'
import { FC } from 'react'
import './airport-select.scss'
import LensSvg from '@/shared/assets/images/MagnifyingGlass.svg'
import PinSvg from '@/shared/assets/images/MapPin.svg'
import { IAirport } from '@/shared/api/aviabooking'
import { useAppSelector } from '@/shared/lib/redux'
import { selectCountriesMap } from '@/entities/aviabooking-reference'

interface AirportSelectProps extends Props<{
    airport: IAirport;
    value: string;
    label: string;
}, false> {}

export const AirportSelect: FC<AirportSelectProps> = ({ ...props }) => {
    const countries = useAppSelector(selectCountriesMap)

    return (
        <Select 
            className={`w-full text-color-dark flex items-center bg-white rounded-full`} 
            classNames={{
                control: () => '!border-0 !border-none !min-h-[auto] !p-0 !m-0 !outline-0 !h-min w-full !border-transparent !shadow-none',
                valueContainer: () => '!border-0 !outline-0 !p-0',
                menu: () => '!rounded-3xl !py-3 !no-scrollbar !overflow-hidden !min-w-[300px]',
                menuPortal: () => '!flex !items-center',
                groupHeading: () => 'text-2xl font-mediumttf !text-color-dark border-b pb-2',
                placeholder: () => "font-bold !text-zinc-400",
                singleValue: () => "overflow-hidden text-ellipsis text-nowrap"
            }}
            noOptionsMessage={() => (
                <div className='w-full flex-col flex items-center'>
                    <div className='py-8'>
                        <LensSvg width={44} height={44} />
                    </div>
                    <div className='mb-3 text-color-dark font-semibold text-xl'>
                        Ничего не нашли
                    </div>
                    <div className='text-base'>
                        Проверьте, правильно ли вы написали название
                    </div>
                </div>
            )}
            formatOptionLabel={(data, meta) => {
                if (meta.context === 'menu') {
                    return (
                        <div className='flex items-center'>
                            <div className='pr-3 pl-1 text-zinc-300'>
                                <PinSvg height={30} width={30} />
                            </div>
                            <div className='flex flex-col w-full'>
                                <div className='inline-block w-[230px] font-normal text-nowrap text-[15px] text-color-dark overflow-hidden overflow-ellipsis'>
                                    {data.airport.city}
                                    {Boolean(data.airport.name) &&
                                        <span className='text-zinc-400 text-ellipsis font-light text-[15px]'>&nbsp;{data.airport.name}</span>
                                    }
                                </div>
                                <div className='text-xs text-zinc-400'>
                                    {countries[data.airport.country_code]?.name}
                                </div>
                            </div>
                        </div>
                    )
                } else if (meta.context === 'value') {
                    return data.label
                } else {
                    return data.label
                }
            }}
            components={{
                DropdownIndicator: () => null,
                IndicatorSeparator: () => null,
                MenuList: (props) => <MenuList {...props}  />,
            }}
            classNamePrefix='airports_select'
            {...props}
        />
    )
}